import React from 'react';
import moment from 'moment';

import { Table, } from 'react-bootstrap';
import IconButton from '@material-ui/core/IconButton';

import LaunchIcon from '@material-ui/icons/Launch';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import history from '../../history';
import ConfirmDialog from '../ConfirmDialog';
import useModal from '../../hooks/useModal';


function ServersTable({ servers, onDelete, onEdit, }) {
  const [selectedServerId, setSelectedServerId] = React.useState(undefined);
  const deleteModal = useModal((serverId) => setSelectedServerId(serverId),
    () => setSelectedServerId(undefined));
  const selectedServer = React.useMemo(() => servers.find(({ _id, }) => selectedServerId === _id),
    [servers, selectedServerId]);


  function onAccessServer(server) {
    localStorage.setItem('idHost', server._id);
    localStorage.setItem('name_host', server.host);
    history.push('/cad/empresas/script');
  }

  function onDeleteConfirmed() {
    onDelete(selectedServer.idEmpresa, selectedServer._id);
    deleteModal.onClose();
  }


  return (
    <Table
      striped
      bordered
      responsive
      hover
      size="sm"
    >
      <thead>
        <tr>
          <th>Nome do host</th>
          <th>Data da criação</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {
          servers
            .map((server) => {
              return (
                <tr key={server._id} >
                  <td>
                    {server.host}
                  </td>

                  <td>
                    {moment(server.createdAt).format('DD/MM/YY')}
                  </td>

                  <td
                    style={{
                      width: '130px',
                    }}
                  >
                    <IconButton
                      onClick={() => onAccessServer(server)}
                      color="primary"
                      size="small"
                    >
                      <LaunchIcon />
                    </IconButton>

                    <IconButton
                      onClick={() => onEdit(server._id)}
                      disabled={undefined == onEdit}
                      color="primary"
                      size="small"
                    >
                      <EditIcon />
                    </IconButton>

                    <IconButton
                      onClick={() => deleteModal.onOpen(server._id)}
                      disabled={undefined == onDelete}
                      color="secondary"
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </td>
                </tr>
              );
            })
        }
      </tbody>

      <ConfirmDialog
        open={deleteModal.value}
        onClose={() => deleteModal.onClose()}
        onConfirm={onDeleteConfirmed}
        text="Tem certeza que deseja excluir o host?"
        secondaryText="O host será excluído permanentemente"
        confirmationButtonLabel="Excluir"
        buttonBackgroundColor="red"
      />
    </Table>
  )
}

export default ServersTable;
